import { css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { TmBaseComponent } from '..';
import { arrowBackIcon } from '../assets/icons/icon-arrow-back';

export const tagName = 'tm-bottom-sheet';
@customElement(tagName)
export class TmBottomSheet extends TmBaseComponent {
    @property({ type: Boolean })
    public open = false;

    @property({ type: Boolean })
    public shadow = true;

    @property({ type: Number })
    public top = 0;

    @property({ type: String, reflect: true })
    public direction: 'horizontal' | 'vertical' = 'vertical';

    @property({ type: Boolean })
    public closeable = true;

    @property({ type: Boolean })
    public loading = false;

    protected render() {
        return html`<div
            class=${classMap({
                'overlay fixed top-0 left-0 w-full flex flex-col bg-page overflow-y-auto': true,
                'h-full': this.open,
                overlayOpen: this.open,
                overlayHidden: !this.open,
            })}
            style=${`top: ${this.top}px`}
        >
            <div class="bg-header pt-[--safe-area-top]">
                <header
                    class="relative flex items-center p-2.5 text-light bg-header h-[--header-height]"
                >
                    <div class="fixed left-0 w-full text-center text-lg font-normal">
                        <slot name="header-center"></slot>
                    </div>
                    <div class="flex flex-row justify-between items-center w-full z-10">
                        <div class="header-back flex items-center w-6 h-12 cursor-pointer">
                            ${this.renderBackButton()}
                        </div>
                        <div class="header-actions">
                            <slot name="header-right"></slot>
                        </div>
                    </div>
                </header>
            </div>
            <slot name="fdic-sign"></slot>
            <div
                class=${classMap({
                    'flex flex-col h-full overflow-y-auto': true,
                })}
            >
                ${this.renderLoading()}
                <slot
                    class=${classMap({
                        shadow: this.shadow,
                    })}
                ></slot>
            </div>
        </div>`;
    }

    private renderBackButton() {
        return this.closeable
            ? html`<button
                  id="back-button"
                  class="cursor-pointer border-none outline-none bg-transparent"
                  @click=${() => this.dispatchEvent(new CustomEvent('close'))}
              >
                  ${arrowBackIcon}
              </button>`
            : nothing;
    }

    private renderLoading() {
        return this.loading ? html`<tm-blocking-loader></tm-blocking-loader>` : nothing;
    }

    public static get styles() {
        return [
            css`
                :host {
                    --header-height: var(--navbar-height, 40px);
                    display: block;
                }
                path {
                    fill: #fff;
                }
                .overlayHidden {
                    height: 0;
                    opacity: 0;
                    visibility: hidden;
                    -webkit-transition:
                        opacity 0.5s,
                        visibility 0s 0.5s;
                    transition:
                        all 0.5s,
                        height 0s 0.4s,
                        visibility 0s 0.5s;
                    transform: translate3d(0, 100%, 0);
                }
                :host([horizontal]) .overlayHidden {
                    transform: translate3d(100%, 0, 0);
                }
                :host([vertical]) .overlayHidden {
                    transform: translate3d(0, 100%, 0);
                }
                .overlayOpen {
                    opacity: 1;
                    visibility: visible;
                    z-index: 100;
                    -webkit-transition: opacity 0.5s;
                    transition:
                        all 0.5s,
                        height 0s;
                    transform: translate3d(0, 0, 0);
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmBottomSheet;
    }
}
